import type { CookieConsentConfig } from 'vanilla-cookieconsent';
import { getClientId } from 'utils/getClientId';
import { getVisitorId } from 'utils/getVisitorId';

const pluginConfig: CookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom left',
      equalWeightButtons: true,
      flipButtons: false,
    },
    // No need for a preferences modal in this simplified version
    preferencesModal: {
      layout: 'box',
      position: 'left',
      equalWeightButtons: true,
      flipButtons: false,
    },
  },

  onFirstConsent: function () {
    console.log('[CookieConsent] onFirstAction fired');

    // Get client and visitor IDs for logging
    const clientId = getClientId()
    const visitorId = getVisitorId()

    console.log('[CookieConsent] Customer accepted cookies on first visit', {
      event: 'COOKIE_CONSENT_ACCEPT_ALL',
      clientId,
      visitorId,
      timestamp: new Date().toISOString(),
      url: window.location.href
    });
  },

  onConsent: function ({ cookie }) {
    console.log('[CookieConsent] onConsent fired ...');

    // Get client and visitor IDs for logging
    const clientId = getClientId();
    const visitorId = getVisitorId()

    console.log('[CookieConsent] Customer updated cookie consent', {
      event: 'COOKIE_CONSENT_UPDATE',
      clientId,
      visitorId,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      acceptedCategories: cookie.categories
    });
  },

  // Simplified categories - just keeping necessary cookies
  categories: {
    necessary: {
      readOnly: true,
      enabled: true,
    }
  },

  language: {
    default: 'en',

    translations: {
      en: {
        consentModal: {
          title: "We Use Cookies",
          description: 'Cookies help us ensure our site works properly, continually make improvements, and personalize your experience.',
          acceptAllBtn: 'ACCEPT ALL',
          // Remove buttons we don't need
          acceptNecessaryBtn: '',
          showPreferencesBtn: '',
          footer: '',
        },
        // Keep the preferences modal minimal since it won't be shown in normal flow
        preferencesModal: {
          title: 'Cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Cookie Usage',
              description:
                'We use cookies to ensure the basic functionalities of the website and to enhance your online experience.',
            },
            {
              title: 'Strictly necessary cookies',
              description: 'These cookies are essential for the website to function properly.',
              linkedCategory: 'necessary',
            }
          ],
        },
      },
    },
  },
};

export default pluginConfig;
